<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4" style="max-width: 1300px;">

      <div class="vx-row no-gutter justify-center items-center">
        <div class="vx-col hidden lg:block lg:w-1/2">
          <img alt="login" class="mx-auto" width="300px" draggable="false"
               src="https://cdn.discordapp.com/attachments/746242308084858900/859142541987151922/IP_Logo_White.png">
        </div>

        <div class="vx-col sm:w-full md:w-full lg:w-1/2 rounded frosted-container">
          <vx-card class="bg-transparent">
            <div slot="no-body">
              <div class="p-8">
                <div class="vx-card__title ">
                  <h2 class="mb-4">Login</h2>
                  <p>Welcome Back to Intellectual Point Simulations</p>
                </div>

                <div class="con-tab con-slot-tabs">
                  <login-jwt></login-jwt>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import LoginJwt from './LoginJWT.vue'

export default {
  components: {LoginJwt},
  created () {

    delete this.$http.defaults.headers.common['Authorization']

    //Set Base URL
    //    this.$http.defaults.baseURL = 'https://learn-api.intellectualpoint.com/v1/'
    this.$http.defaults.baseURL = 'http:///localhost:49538/v1/'

    if (localStorage['accessToken'] && localStorage['accessToken']) {
      this.$router.push('/dashboard')
    }

  }
}
</script>

<style lang="scss">


.layout--full-page {
  .bg-img {
    background-color: #333B48;
    background-image: url(https://cdn.discordapp.com/attachments/746242308084858900/859159448895619082/162490995521347824.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .full-page-bg-color {
    background-color: #eff2f7;
  }
}

#page-login {
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      padding-top: 3rem;
    }
  }

  .frosted-container {
    box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.18);
    backdrop-filter: blur(55px);
  }

  input {
    background-color: transparent;
  }


}

</style>
